module.exports = __webpack_public_path__ + "04f8d6726b540accfe4657148dbcfb1f.MP3";